import { useState, useContext, useEffect } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import classes from './MenuCard.module.scss';
import iconInfo from '../../../images/icon-info.svg';
import menuCap from '../../../images/menu-cap.png';
import MenuCardModal from '../MenuCardModal/MenuCardModal';
import { MenuContext } from '../../../context/menuContext';
import { GeneralContext } from '../../../context/generalContext';
import MenuPhotoModal from '../MenuPhotoModal/MenuPhotoModal';
import MenuCardModalEnglish from '../MenuCardModalEnglish/MenuCardModalEnglish';
import MenuCardSticker from './MenuCardSticker/MenuCardSticker';
import { getSeasonalColor } from './lib/getSeasonalColor/getSeasonalColor';

export default function MenuCard({ item, topDescrRu, handleItemChoices, menuSectionsNotEmpty, showChoice }) {
  const { selectedMenuSection } = useContext(MenuContext);
  const { activeCity, activeLanguage, windowWidth } = useContext(GeneralContext);
  const [modalActive, setModalActive] = useState(false);
  const [englishModalActive, setEnglishModalActive] = useState(false);
  const [hasInfo, setHasInfo] = useState(false);
  const [isDrink, setIsDrink] = useState(false);
  const [modalPhotoActive, setModalPhotoActive] = useState(false);
  const [choices, setChoices] = useState([]);
  const seasonalStickerColor = getSeasonalColor(new Date().getMonth());

  const openModal = () => {
    if (hasInfo) {
      activeLanguage === 1 ? setModalActive(true) : setEnglishModalActive(true);
    }
  };

  useEffect(() => {
    const choicesArr = handleItemChoices(item);
    setChoices(choicesArr);
  }, [item]);

  useEffect(() => {
    item.info[0]?.text || item.description_ru || (choices.length > 2 && !isDrink)
      ? setHasInfo(true)
      : setHasInfo(false);
  }, [item, choices]);

  useEffect(() => {
    menuSectionsNotEmpty.find(section => section.id === selectedMenuSection)?.tag === 'drink'
      ? setIsDrink(true)
      : setIsDrink(false);
  }, [selectedMenuSection, menuSectionsNotEmpty]);

  return (
    <>
      <div
        className={topDescrRu ? 'lunch-card' : isDrink ? classes.drinksCard : classes.menuCard}
        onClick={() => {
          if (hasInfo) openModal();
        }}
        style={hasInfo ? { cursor: 'pointer' } : { cursor: 'default' }}
      >
        {item.img ? (
          <LazyLoadComponent>
            <div style={{ backgroundImage: `url(${item.img})` }} className={classes.menuCardImg}>
              <div className={classes.menuCardImgHover} />
              {Boolean(item.isSeasonal) && (
                <MenuCardSticker color={seasonalStickerColor} name='Сезонное' name_en='Seasonal' />
              )}
            </div>
          </LazyLoadComponent>
        ) : (
          <LazyLoadComponent>
            <div
              className={topDescrRu ? classes.disabled : `${classes.menuCardImg} ${classes.menuCardImgEmpty}`}
              style={{ backgroundImage: `url(${menuCap})` }}
            >
              {Boolean(item.isSeasonal) && (
                <MenuCardSticker color={seasonalStickerColor} name='Сезонное' name_en='Seasonal' />
              )}
            </div>
          </LazyLoadComponent>
        )}

        <div className={classes.menuCardDescription}>
          <div>
            <p className={topDescrRu ? 'lunch-card-name' : classes.menuCardName}>
              {activeLanguage === 1 ? item.name : item.name_en || item.name}
            </p>
            {isDrink && (
              <p className={classes.menuCardDescrText}>
                {activeLanguage === 1
                  ? item.info[0]?.text || item.description_ru
                  : item.info[0]?.text_en || item.description_en || item.info[0]?.text || item.description_ru}
              </p>
            )}
          </div>
        </div>
        <div className={classes.menuCardPriceDiv}>
          {activeCity !== 0 &&
            choices?.slice(0, 2)?.map((choice, index) => (
              <div key={index} className={isDrink ? classes.menuCardPriceChoicesDrink : classes.menuCardPriceChoices}>
                <div>
                  <div
                    className={topDescrRu ? 'lunch-card-price' : classes.menuCardPrice}
                    dangerouslySetInnerHTML={{
                      __html: `${choice.price.toLocaleString()}&nbsp;${activeCity === 6 ? 'uzs' : '&#8381;'}`,
                    }}
                  />
                </div>

                <div>
                  {isDrink ? (
                    <div
                      className={
                        showChoice
                          ? classes.menuCardChoiceDrink
                          : windowWidth > 767
                            ? classes.disabled
                            : classes.menuCardChoiceDrink
                      }
                    >
                      {activeLanguage === 1 ? choice.name : choice.name_en || choice.name}
                    </div>
                  ) : (
                    <div className={classes.menuCardChoice}>
                      {activeLanguage === 1 ? choice.name : choice.name_en || choice.name}
                    </div>
                  )}
                </div>
              </div>
            ))}
          {choices?.length > 2 && !isDrink && <div className={classes.plusChoices}>{`+${choices.length - 2}`}</div>}
          {!isDrink && <>{hasInfo && <img className={classes.menuCardInfoIcon} src={iconInfo} alt='info icon' />}</>}
        </div>
      </div>
      <MenuCardModal modalActive={modalActive} setModalActive={setModalActive} item={item} choices={choices} />
      <MenuCardModalEnglish
        modalActive={englishModalActive}
        setModalActive={setEnglishModalActive}
        item={item}
        choices={choices}
      />
      <MenuPhotoModal
        modalPhotoActive={modalPhotoActive}
        setModalPhotoActive={setModalPhotoActive}
        item={item}
        image={item.img}
      />
    </>
  );
}
